import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import FrameCard1 from "Utils/Assets/Images/FrameCard1.png";
import FrameCard2 from "Utils/Assets/Images/FrameCard2.png";
import FrameCard3 from "Utils/Assets/Images/FrameCard3.png";

const WhoWeAre = () => {
    return (
        <div className={styles.whoWeAre}>
            <MeetUsWrapper>
                <div className={styles.contentWrapper}>

                    {/* Title with background */}
                    <div
                        className={styles.titleWrapper}
                        data-aos="fade-up"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <h1 className={styles.title}>Who We Are</h1>
                        <p className={styles.des}>
                            MeetUsVR is more than just a platform; it's a revolutionary movement designed to empower users,
                        </p>
                        <p className={styles.des}>
                            brands, and creators in a phygital ecosystem—bridging the virtual and real worlds.
                        </p>
                    </div>

                    {/* Cards Section */}
                    <div className={styles.Cards}>
                        <div
                            className={styles.Card}
                            data-aos="fade-right"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div>
                                <p className={styles.cardTitle}>Empower individuals</p>
                                <p className={styles.cardDescription}>
                                    To connect and earn through blockchain-<br /> powered engagement.
                                </p>
                            </div>
                            <div className={styles.cardImage}>
                                <img src={FrameCard1} alt="Frame Card 1" />
                            </div>
                        </div>

                        <div
                            className={styles.Card1}
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div>
                                <p className={styles.cardTitle}>Enable brands</p>
                                <p className={styles.cardDescription}>
                                    To tap into virtual experiences and reach new audiences.
                                </p>
                            </div>
                            <div className={styles.cardImage}>
                                <img src={FrameCard2} alt="Frame Card 2" />
                            </div>
                        </div>

                        <div
                            className={styles.Card1}
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                        >
                            <div>
                                <p className={styles.cardTitle}>Create an inclusive economy</p>
                                <p className={styles.cardDescription}>
                                    Where participation is rewarded equally with their individual activity.
                                </p>
                            </div>
                            <div className={styles.cardImage}>
                                <img src={FrameCard3} alt="Frame Card 3" />
                            </div>
                        </div>
                    </div>

                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default WhoWeAre;
